import { getCookie } from "./Browser"

export const isMobile = () => {
    return screen.width <= 768 || window.innerWidth <= 768
}

export const isMobileApp = () => Boolean(getCookie("__app_session"));